/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { Dispatch } from "react";
import { Credentials, Effect } from "../../utils/Interfaces";
import { AnyAction } from "@reduxjs/toolkit";
import axios from "axios";
import { login, logout } from "./authSlice";

export function loginHandler(authData: Credentials, onLoginSuccess: Effect, onLoginError: Effect, dispatch: Dispatch<AnyAction>) {
    axios
        .post(`${process.env.REACT_APP_API_ENDPOINT}/api/login`, authData, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((resData) => {
            localStorage.setItem("id", resData.data.id);
            localStorage.setItem("username", resData.data.username);
            localStorage.setItem("firstName", resData.data.first_name);
            localStorage.setItem("lastName", resData.data.last_name);
            localStorage.setItem("token", resData.data.token);
            localStorage.setItem("email", resData.data.email);
            localStorage.setItem("roles", JSON.stringify(resData.data.roles));

            dispatch(
                login({
                    id: resData.data.id,
                    username: resData.data.username,
                    last_name: resData.data.last_name,
                    first_name: resData.data.first_name,
                    email: resData.data.email,
                    token: resData.data.token,
                    roles: resData.data.roles,
                })
            );

            onLoginSuccess();
        })
        .catch((err) => {
            onLoginError();
        });
}

export function logoutHandler(dispatch: Dispatch<AnyAction>) {
    dispatch(logout());

    window.location.href = "/";

    localStorage.removeItem("id");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("roles");
    localStorage.removeItem("username");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("workOrderTabId");
    localStorage.removeItem("techDashTabId");
    localStorage.removeItem("adminTabId");
}
